// extracted by mini-css-extract-plugin
export default {"nav":"NavBar_nav__IQUWY"};